/*
@@ auther govind dindewad
*/
import React, { useCallback, useEffect, useRef, useState } from "react";
import "./styleAddPlatform.css";
import EditorJS from "@editorjs/editorjs";
import Header from "@editorjs/header";
import List from "@editorjs/list";
import ImageTool from "@editorjs/image"
import { setIsAddPlatform, setPlatformList } from "../../features/platforms/platformsSlice";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";

import ReactCrop, {
    centerCrop,
    makeAspectCrop,
    Crop,
    PixelCrop,
    convertToPixelCrop,
} from 'react-image-crop'
import 'react-image-crop/dist/ReactCrop.css'
import { postCategory, postPlatform, updatePlatform } from "../../services/platformServices";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";



/**
 * @Author Govind Dindewad
 * 
 * Function to calculate and center an aspect crop based on media dimensions.
 * @param {number} mediaWidth - The width of the media.
 * @param {number} mediaHeight - The height of the media.
 * @param {number} aspect - The aspect ratio to maintain.
 * @returns {object} The centered aspect crop configuration.
 */
function centerAspectCrop(
    mediaWidth,
    mediaHeight,
    aspect,
) {
    return centerCrop(
        makeAspectCrop(
            {
                unit: '%',
                width: 90,
            },
            aspect,
            mediaWidth,
            mediaHeight,
        ),
        mediaWidth,
        mediaHeight,
    )
}

function INCSUBAddPlatform(prevPlatform) {
    const editorInstanceRef = useRef(null); // Reference for Editor.js instance
    const categoryList = useSelector((state) => state.platforms.categoryList); // Redux state for category list
    const [imgSrc, setImgSrc] = useState(''); // State for image source
    const previewCanvasRef = useRef(null); // Reference for preview canvas
    const imgRef = useRef(null); // Reference for image element
    const hiddenAnchorRef = useRef(null); // Reference for download anchor
    const blobUrlRef = useRef(''); // Reference for blob URL
    const [crop, setCrop] = useState(null); // State for crop configuration
    const [completedCrop, setCompletedCrop] = useState(null); // State for completed crop
    const [aspect] = useState(1 / 1); // Default aspect ratio (square)
    const [croppedImageUrl, setCroppedImageUrl] = useState(null); // State for cropped image URL
    const dispatch = useDispatch(); // Redux dispatch function
    const [pNameCount, setPNameCount] = useState(0); // State for platform name character count
    const platformList = useSelector((state) => state.platforms.platformList); // Redux state for platform list
    const navigate = useNavigate(); // Hook for navigation

    // State to store new platform details
    const [newPlatform, setNewPlatform] = useState({
        platformName: '',
        platformImageFile: null,
        platformDescription: '',
        platformSecurityDocument: '',
        platformRating: '',
        platformReviewCount: '',
        platformCredentialType: '',
        isVisible: false,
        isBestSeller: false,
        encryptedCategoryId: '',
        platformCategory: "",
        platformImage: null,
    })

    /**
    * Effect to update platform state when previous platform data changes.
    */
    useEffect(() => {
        if (prevPlatform.platform) {
            setNewPlatform(prevPlatform.platform);
        }

    }, [prevPlatform])

    /**
   * Effect to initialize and clean up Editor.js.
   */
    useEffect(() => {
        if (prevPlatform.platform) {
            setNewPlatform(prevPlatform.platform);
        }

        if (editorInstanceRef.current) {
            editorInstanceRef.current.destroy();
            editorInstanceRef.current = null;
        }

        try {
            editorInstanceRef.current = new EditorJS({
                holder: "editorjs",
                tools: {
                    header: Header,
                    list: List,
                    // image: {
                    //     class: ImageTool,
                    //     config: {
                    //         uploader: {
                    //             uploadByFile: (file) => {
                    //                 // Handle file upload to your server here
                    //                 return new Promise((resolve, reject) => {
                    //                     const formData = new FormData();
                    //                     formData.append('file', file);

                    //                     fetch('http://localhost:3000/upload', {
                    //                         method: 'POST',
                    //                         body: formData,
                    //                     })
                    //                         .then((response) => response.json())
                    //                         .then((data) => {
                    //                             resolve({
                    //                                 success: 1,
                    //                                 file: {
                    //                                     url: data.url, // URL of the uploaded image
                    //                                     // optional:
                    //                                     name: data.name,
                    //                                     size: data.size,
                    //                                 },
                    //                             });
                    //                         })
                    //                         .catch((error) => {
                    //                             console.error(error);
                    //                             reject({ success: 0, message: 'File upload failed' });
                    //                         });
                    //                 });
                    //             },
                    //             uploadByUrl: (url) => {
                    //                 // Handle image fetching by URL here
                    //                 return new Promise((resolve) => {
                    //                     resolve({
                    //                         success: 1,
                    //                         file: {
                    //                             url: url, // Use the provided URL
                    //                         },
                    //                     });
                    //                 });
                    //             },
                    //         },
                    //     },
                    // },
                },
                placeholder: "Start typing here...",
                data: prevPlatform.platform?.platformSecurityDocument
                    ? JSON.parse(prevPlatform.platform.platformSecurityDocument)
                    : null,
                onChange: async () => {
                    if (editorInstanceRef.current) {
                        const content = await editorInstanceRef.current.save();
                        changeEditorJs(content);
                    }
                },
            });
        } catch (error) {
            console.error("Error initializing Editor.js:", error);
        }

        return () => {
            if (editorInstanceRef.current) {
                editorInstanceRef.current.destroy();
                editorInstanceRef.current = null;
            }
        };
    }, [prevPlatform]);

    /**
      * Function to handle Editor.js content changes and update state.
      */
    const changeEditorJs = async (e) => {
        if (editorInstanceRef.current) {
            try {
                const savedData = await editorInstanceRef.current.save();
                setNewPlatform((prev) => ({
                    ...prev,
                    platformSecurityDocument: JSON.stringify(savedData),
                }));

            } catch (error) {
                console.error('Error saving content:', error);
            }
        }
    };


    /**
     * Handles file selection and reads the image file as a data URL.
     * @param {Event} e - The file input change event.
     */
    function onSelectFile(e) {
        if (e.target.files && e.target.files.length > 0) {
            setCrop(null);
            const reader = new FileReader();
            reader.addEventListener('load', () => setImgSrc(reader.result?.toString() || ''));
            reader.readAsDataURL(e.target.files[0]);
        }
    }


    /**
 * Handles the image load event and calculates an initial centered crop.
 * @param {Event} e - The image load event.
 */
    function onImageLoad(e) {
        if (aspect) {
            const { width, height } = e.currentTarget;
            setCrop(centerAspectCrop(width, height, aspect));
        }
    }

    /**
 * Handles the download of the cropped image by extracting the selected crop area from the original image.
 */
    async function onDownloadCropClick() {
        const image = imgRef.current;
        const previewCanvas = previewCanvasRef.current;

        if (!image || !previewCanvas || !completedCrop?.width || !completedCrop?.height) {
            console.error("Crop canvas does not exist or is incomplete.");
            return;
        }

        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;

        // Create an offscreen canvas
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        if (!ctx) {
            console.error("No 2D context on canvas.");
            return;
        }

        canvas.width = completedCrop.width * scaleX;
        canvas.height = completedCrop.height * scaleY;

        ctx.drawImage(
            image,
            completedCrop.x * scaleX,
            completedCrop.y * scaleY,
            completedCrop.width * scaleX,
            completedCrop.height * scaleY,
            0,
            0,
            canvas.width,
            canvas.height
        );

        // Convert canvas to Blob
        canvas.toBlob((blob) => {
            if (!blob) {
                console.error("Failed to create Blob from canvas.");
                return;
            }

            // Generate a URL for the Blob
            if (blobUrlRef.current) {
                URL.revokeObjectURL(blobUrlRef.current);
            }
            blobUrlRef.current = URL.createObjectURL(blob);

            // Convert canvas to Data URL
            const croppedImageUrl = canvas.toDataURL('image/png');

            // Update state with the cropped image
            setNewPlatform((prev) => ({
                ...prev,
                platformImage: croppedImageUrl,
                platformImageFile: blob
            }));
        }, 'image/png');
    }

    /**
 * Handles platform name input and updates the state while enforcing a character limit.
 * @param {Event} e - The input change event.
 */
    const handlePlatformName = (e) => {
        if (e.target.value.length < 21) {
            setPNameCount(e.target.value.length)
            setNewPlatform({
                ...newPlatform,
                platformName: e.target.value
            })
        }

    }


    /**
 * Handles category selection and updates the platform state.
 * @param {Event} e - The event triggered by category selection.
 */
    const handleCategory = async (e) => {
        const category = await categoryList.filter((category) => category.categoryName === e.target.value);

        if (category.length > 0) {
            setNewPlatform({
                ...newPlatform,
                platformCategory: category[0].categoryName,
                encryptedCategoryId: category[0].categoryId
            });
        }

    }

    /**
 * Handles credential type selection and updates the platform state.
 * @param {Event} e - The event triggered by selecting a credential type.
 */
    const handleCredentialType = async (e) => {
        setNewPlatform({
            ...newPlatform,
            platformCredentialType: e.target.value
        });

    }

    // State to track if the rating input is valid
    const [validrating, setValidRating] = useState(true);

    /**
 * Validates and updates the platform rating state.
 * Allows numbers between 0-10, with optional decimals.
 * @param {Event} e - The event triggered by rating input.
 */
    const handleRating = (e) => {
        const ratingValue = e.target.value;
        const regex = /^(10(\.0+)?|[0-9](\.\d+)?)$/; // Validates ratings from 0 to 10

        if (e.target.value > 5) {
            return
        }
        setNewPlatform({
            ...newPlatform,
            platformRating: e.target.value
        });
        if (regex.test(ratingValue) && (e.target.value <= 5)) {

            setValidRating(true)
        } else {
            setValidRating(false)
        }
    };


    /**
     * Validates and updates the review count.
     * Only allows numeric input.
     * @param {Event} e - The event triggered by review count input.
     */
    const handleReviewCount = (e) => {
        const regex = /^[0-9]*$/
        if (regex.test(e.target.value)) {
            setNewPlatform({
                ...newPlatform,
                platformReviewCount: e.target.value
            });
        }
    }

    /**
 * Updates the platform description.
 * @param {Event} e - The event triggered by description input.
 */
    const handlePlatformDescription = (e) => {
        setNewPlatform({
            ...newPlatform,
            platformDescription: e.target.value
        });
    }

    /**
 * Toggles the visibility status of the platform.
 */
    const handleVisibility = (e) => {
        setNewPlatform({
            ...newPlatform,
            isVisible: !newPlatform.isVisible
        });
    };

    /**
 * Toggles the "Best Seller" status of the platform.
 */
    const handleBestSeller = (e) => {
        setNewPlatform({
            ...newPlatform,
            isBestSeller: !newPlatform.isBestSeller
        });
    };

    // State variables for validation and loading status
    const [isEmptyField, setIsEmptyField] = useState(false);
    const [loader, setLoader] = useState(false);

    /**
 * Adds a new platform after validating input fields.
 */
    const addPlatform = async () => {
        setLoader(true)
        const isInvalid = [
            newPlatform.platformName,
            newPlatform.platformCategory,
            newPlatform.platformCredentialType,
            newPlatform.platformImageFile,
            newPlatform.platformRating,
            newPlatform.platformReviewCount,
            newPlatform.platformSecurityDocument,
            newPlatform.platformDescription
        ].some(field => field === '' || field === null || field === undefined);
console.log("hell")
        if (isInvalid) {
            setIsEmptyField(true);
            setLoader(false)
            return;
        }

        try {
            const data = await postPlatform(newPlatform);

            if (data.status === 201) {
                toast.done("Platform Added successfuly");

                if (platformList.isLastPage) {
                    const updatedPlatformList = [
                        ...(platformList?.platformList ?? []),
                        {
                            ...newPlatform,
                            platformId: data.data.data.idValue,
                            platformImageFile: null,
                            platformImage: newPlatform.platformImage
                        }
                    ];
                    dispatch(setPlatformList({
                        ...platformList,
                        platformList: updatedPlatformList
                    }));
                }
            }
            if (data.status === 401) {
                window.localStorage.setItem('token', null)
                navigate('/login')
                return
            }
            if ([409, 400].includes(data.status)) {
                toast.error(data.data.message);
            }
            setLoader(false)
            dispatch(setIsAddPlatform(false))
        } catch (err) {
            console.error("Error adding platform:", err);
            setLoader(false)
        }
    };


    /**
 * Updates an existing platform after checking for changes.
 */
    const handlePlatform = async () => {
console.log("hello")
        const arePlatformsEqual = _.isEqual(prevPlatform.platform, newPlatform);
        if (arePlatformsEqual) {
            toast.warning("No change in previous data");
            return
        }
        setLoader(true);

        const isInvalid = [
            newPlatform.platformName,
            newPlatform.platformCategory,
            newPlatform.platformCredentialType,
            newPlatform.platformImage,
            newPlatform.platformRating,
            newPlatform.platformReviewCount,
            newPlatform.platformSecurityDocument,
            newPlatform.platformDescription,
            newPlatform.platformId
        ].some(field => field === '' || field === null || field === undefined);

        if (isInvalid) {
            setIsEmptyField(true);
            setLoader(false)
            return;
        }

        try {
            const data = await updatePlatform(newPlatform);

            if (data.status === 200) {
                const updatedList = platformList.platformList.map(platform =>
                    platform.platformId === newPlatform.platformId
                        ? { ...platform, ...newPlatform }
                        : platform
                );
                dispatch(setPlatformList({
                    ...platformList,
                    platformList: updatedList
                }));

            } else if (data.status === 301) {
                toast.error("Network Error");
            } else if (data.status === 500) {
                toast.error("Internal server error");
            } if (data.status === 401) {
                window.localStorage.setItem('token', null)
                navigate('/login')
                return
            }
            if ([409, 400, 403].includes(data.status)) {
                toast.error(data.data.message);
            } else {
                toast.error(data.data.message);
            }
            setLoader(false)
            dispatch(setIsAddPlatform(false))
        } catch (err) {
            console.error("Error adding platform:", err);
            setLoader(false)
        }
    }

    const [imageError, setImageError] = useState(null);
    function onSelectFileI(e) {
        if (e.target.files && e.target.files.length > 0) {

            const file = e.target.files[0];

            // Create a new Blob (optional, as file is already a Blob)
            const blob = new Blob([file], { type: file.type });
            // Store the blob in state (assuming you have a setBlob state setter)
            setNewPlatform((prev) => ({
                ...prev,
                platformImageFile: blob,
            }))

            // Convert the file to a Data URL for image preview
            const reader = new FileReader();
            reader.onload = function (event) {
                const img = new Image();
                img.onload = function () {
                    const aspectRatio = img.width / img.height;
                    const targetRatio = 1 / 1;

                    // Allow for a small tolerance due to potential rounding
                    const tolerance = 0.01;
                    if (Math.abs(aspectRatio - targetRatio) > tolerance) {
                        setImageError(true);

                    } else {
                        setImageError(false);
                    }


                    const blob = new Blob([file], { type: file.type });
                    setNewPlatform((prev) => ({
                        ...prev,
                        platformImage: reader.result?.toString() || '',
                    }))
                };
                img.src = event.target.result;
            };
            reader.readAsDataURL(file);
        }
    }




    return (
        <div className="INCSUBAdd_platform">
            <div className="INCSUBAdd_platform_container">
                <div className="INCSUBAdd_platform_feilds_container" >
                    <div className="INCSUBAdd_platform_heading_container">
                        <svg className="cancel_btn" onClick={() => dispatch(setIsAddPlatform(false))} width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M1.46416 1.47683C1.77145 1.16963 2.18818 0.997049 2.6227 0.997049C3.05721 0.997049 3.47394 1.16963 3.78124 1.47683L9.99672 7.69231L16.2122 1.47683C16.3634 1.32032 16.5442 1.19548 16.7441 1.1096C16.944 1.02372 17.1591 0.978515 17.3766 0.976624C17.5942 0.974734 17.81 1.01619 18.0114 1.09859C18.2128 1.18098 18.3957 1.30266 18.5496 1.45652C18.7035 1.61038 18.8251 1.79334 18.9075 1.99473C18.9899 2.19611 19.0314 2.41189 19.0295 2.62947C19.0276 2.84706 18.9824 3.06208 18.8965 3.26201C18.8106 3.46193 18.6858 3.64275 18.5293 3.79391L12.3138 10.0094L18.5293 16.2249C18.8278 16.5339 18.9929 16.9479 18.9892 17.3775C18.9855 17.8072 18.8131 18.2182 18.5093 18.522C18.2055 18.8258 17.7945 18.9982 17.3648 19.0019C16.9352 19.0056 16.5213 18.8405 16.2122 18.542L9.99672 12.3265L3.78124 18.542C3.47218 18.8405 3.05825 19.0056 2.62859 19.0019C2.19894 18.9982 1.78794 18.8258 1.48412 18.522C1.18029 18.2182 1.00796 17.8072 1.00422 17.3775C1.00049 16.9479 1.16566 16.5339 1.46416 16.2249L7.67964 10.0094L1.46416 3.79391C1.15695 3.48661 0.984375 3.06989 0.984375 2.63537C0.984375 2.20085 1.15695 1.78413 1.46416 1.47683Z" fill="black" />
                        </svg>
                        <div className="INCSUBAdd_platform_heading">{prevPlatform?.platform ? "Update Platform" : "Add Platform"}</div>
                    </div>
                    <div className="INCSUBAdd_platform_form_container">
                        <form>
                            <div className="INCSUBAdd_platform_form_fullfeild_container">
                                <label className="platform_name_label">Platform Name <div>{pNameCount}/20</div></label>
                                <input placeholder="Enter name" value={newPlatform.platformName} onChange={handlePlatformName} style={{ border: newPlatform.platformName === '' && isEmptyField ? '1px solid red' : null }} />
                            </div>
                            <div className="INCSUBAdd_platform_form_halffeild_container">
                                <div className="INCSUBAdd_platform_form_fullfeild_container half">
                                    <label>Categories</label>
                                    <select onChange={handleCategory} value={newPlatform.platformCategory} style={{ color: newPlatform.platformCategory === '' ? '#A6A6A6' : null, border: newPlatform.platformCategory === '' && isEmptyField ? '1px solid red' : null }} placeholder="Select a category">
                                        <option value={''} style={{ color: '#A6A6A6' }} disabled selected>Select a Category</option>
                                        {
                                            categoryList && categoryList.map((category, index) => <option value={category.categoryName}>{category.categoryName}</option>)
                                        }
                                    </select>
                                </div>
                                <div className="INCSUBAdd_platform_form_fullfeild_container half">
                                    <label>Credential Type</label>
                                    <select onChange={handleCredentialType} value={newPlatform.platformCredentialType} style={{ color: newPlatform.platformCredentialType === '' ? '#A6A6A6' : null, border: newPlatform.platformCredentialType === '' && isEmptyField ? '1px solid red' : null }} placeholder="Select a Crediantial Type" >
                                        <option value={''} style={{ color: '#A6A6A6' }} disabled selected>Select a Credential type</option>
                                        <option value={"OTP"}>Mobile No</option>
                                        <option value={'USERNAME_PASSWORD'}>Email</option>
                                        <option value={'INVITE_LINK'}>Link</option>
                                    </select>
                                </div>
                            </div>
                            <div className="INCSUBAdd_platform_form_halffeild_container">
                                <div className="INCSUBAdd_platform_image_container">
                                    <label>Image</label>
                                    <div className="INCSUBAdd_platform_image" style={{ border: !newPlatform.platformImageFile && isEmptyField ? '1px solid red' : null }}>
                                        <input className='profile-img-upload' type="file" accept="image/*" onChange={onSelectFileI} />
                                        <svg
                                            width="37"
                                            height="37"
                                            viewBox="0 0 37 37"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M18.5 7.71094V29.2943"
                                                stroke="#606060"
                                                strokeWidth="3.08333"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M7.7085 18.5H29.2918"
                                                stroke="#606060"
                                                strokeWidth="3.08333"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                        {
                                            newPlatform.platformImage && <img className='INCSUBDisplay_img' src={newPlatform.platformImage} alt='/' />
                                        }
                                    </div>
                                    <div className="INCSUBAdd_platform_image_ratio" style={{ color: imageError ? "red" : null }}>
                                        JPG / Size. 1080x1080 (1:1) <br />{imageError ? ' Wrong size' : null}
                                    </div>
                                </div>
                                <div className="INCSUBAdd_platform_ratings_container">
                                    <div className="INCSUBAdd_platform_form_fullfeild_container">
                                        <label>
                                            Rating <span>(On Play Store)</span>
                                        </label>
                                        <input style={{ border: !validrating || (newPlatform.platformRating === '' && isEmptyField) ? '1px solid red' : null }} value={newPlatform.platformRating} onChange={handleRating} placeholder="Enter rating number" type="number" />
                                    </div>
                                    <div className="INCSUBAdd_platform_form_fullfeild_container"></div>
                                    <div className="INCSUBAdd_platform_form_fullfeild_container">
                                        <label>
                                            Reviews <span>(On Play Store)</span>
                                        </label>
                                        <input value={newPlatform.platformReviewCount} onChange={handleReviewCount} placeholder="Enter review numbers" style={{ border: newPlatform.platformReviewCount === '' && isEmptyField ? '1px solid red' : null }} />
                                    </div>
                                </div>
                            </div>
                            <div className="INCSUBAdd_platform_form_fullfeild_container">
                                <label>Security Document</label>
                                <div
                                    id="editorjs"
                                    style={{
                                        padding: "16px",
                                        borderRadius: "5px",
                                        textAlign: "left",
                                        border: newPlatform.platformSecurityDocument === '' && isEmptyField ? '1px solid red' : null
                                    }}
                                ></div>
                            </div>
                            <div className="INCSUBAdd_platform_form_fullfeild_container">
                                <label>
                                    Description <span>(1-2 lines)</span>
                                </label>
                                <textarea value={newPlatform.platformDescription} onChange={handlePlatformDescription} placeholder="Type here...." style={{ border: newPlatform.platformDescription === '' && isEmptyField ? '1px solid red' : null }}></textarea>
                            </div>
                            <div className="INCSUBAdd_platform_form_fullfeild_container">
                                <div className="INCSUBAdd_platform_toggle_container">
                                    <label className="toggle-switch">
                                        {/* The hidden checkbox that holds the toggle state */}
                                        <input
                                            type="checkbox"
                                            checked={newPlatform.isVisible}
                                            onChange={handleVisibility}
                                        />
                                        <span className="slider"></span>
                                        <span className="label-text">Visible </span>
                                    </label>
                                    <label className="toggle-switch">
                                        {/* The hidden checkbox that holds the toggle state */}
                                        <input
                                            type="checkbox"
                                            checked={newPlatform.isBestSeller}
                                            onChange={handleBestSeller}
                                        />
                                        <span className="slider"></span>
                                        <span className="label-text">Best Seller</span>
                                    </label>
                                </div>
                            </div>
                            <div className="INCSUBAdd_platform_form_fullfeild_container">
                                <div className="INCSUBusrupdate_btn submit"
                                    onClick={() => !loader ? (!prevPlatform.platform ? addPlatform() : handlePlatform()) : null}
                                >
                                    {loader ? <div className="INCSUBADD_platform_loader" /> : prevPlatform.platform ? "Update" : "Add"}</div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            {
                imgSrc ?
                    <div className="canvas-holder" style={{
                        position: "absolute",
                        height: "100%",
                        width: "100%",
                        zIndex: "10",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "#0000009c",
                        flexDirection: "column",
                        top: "0px"
                    }}><div className='crop_image_holder'>
                            <div className='image_container'>
                                {!!imgSrc && (
                                    <ReactCrop
                                        crop={crop}
                                        onChange={(_, percentCrop) => setCrop(percentCrop)}
                                        onComplete={(c) => setCompletedCrop(c)}
                                        aspect={aspect}
                                        // minWidth={400}
                                        minHeight={100}
                                    // circularCrop
                                    >
                                        <img
                                            ref={imgRef}
                                            alt="Crop me"
                                            src={imgSrc}
                                            // style={{ transform: `scale(${scale}) rotate(${rotate}deg)` }}
                                            onLoad={onImageLoad}
                                        />
                                    </ReactCrop>
                                )}
                            </div>
                            <div className="image_upload_btn">
                                <div className='upload_btn'>Upload</div>
                                <div className='upload_cancel_btn'>Cancel</div>
                            </div>
                        </div>

                    </div> : null
            }
            {
                imgSrc && (
                    <div className="canvas-holder" style={{
                        position: "absolute",
                        height: "100%",
                        width: "100%",
                        zIndex: "10",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "#0000009c",
                        flexDirection: "column",
                        top: "0px"
                    }}>
                        <div className='crop_image_holder'>
                            <div className='image_container'>
                                <ReactCrop
                                    crop={crop}
                                    onChange={(_, percentCrop) => setCrop(percentCrop)}
                                    onComplete={(c) => setCompletedCrop(c)}
                                    aspect={aspect}
                                >
                                    <img ref={imgRef} alt="Crop me" src={imgSrc} onLoad={onImageLoad} />
                                </ReactCrop>
                            </div>
                            <div className="image_upload_btn">
                                <button className='upload_btn' onClick={() => {
                                    onDownloadCropClick();
                                    setImgSrc(null)
                                }}>Upload</button>
                                <button className='upload_cancel_btn' onClick={() => setImgSrc(null)}>Cancel</button>
                            </div>
                        </div>
                    </div>
                )
            }

            {/* Hidden Anchor for Download */}
            <a ref={hiddenAnchorRef} style={{ display: 'none' }}></a>

            {/* Hidden Canvas for Cropping */}
            <canvas ref={previewCanvasRef} style={{ display: 'none' }} />

        </div>
    );
}

export default INCSUBAddPlatform;
